import { render, staticRenderFns } from "./additionalStaff.vue?vue&type=template&id=17c02624&scoped=true"
import script from "./additionalStaff.vue?vue&type=script&lang=js"
export * from "./additionalStaff.vue?vue&type=script&lang=js"
import style0 from "./additionalStaff.vue?vue&type=style&index=0&id=17c02624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c02624",
  null
  
)

export default component.exports